import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { useNavigate } from 'react-router-dom';
import theme from '../../theme';

export function Footer() {
  const navigate = useNavigate();

  return (
    <View
      style={{
        paddingVertical: 24,
        paddingHorizontal: 48,
        borderTopWidth: theme.borderWidth.thin,
        borderTopColor: theme.colors.borderDefault,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Text
        style={{
          fontFamily: theme.typography.fontMono,
          fontSize: theme.typography.size['2xs'],
          color: theme.colors.textTertiary,
        }}
      >
        © 2026 Stack Technology Limited
      </Text>
      <View style={{ flexDirection: 'row', gap: theme.spacing.space5 }}>
        <Pressable onPress={() => navigate('/privacy')}>
          <Text style={{ fontFamily: theme.typography.fontMono, fontSize: theme.typography.size['2xs'], color: theme.colors.textTertiary }}>
            Privacy
          </Text>
        </Pressable>
      </View>
    </View>
  );
}